import React from 'react';

import Select from 'react-select';

export interface InputSelectProps {
    inputProps: React.InputHTMLAttributes<HTMLInputElement>;
    onChange: (selected: any) => void;
    options: any[];
    className?: string;
    errorText?: string;
    hintText?: string;
    placeholder?: string;
}

const InputSelect: React.FC<InputSelectProps> = (props) => (
    <React.Fragment>
        <Select classNamePrefix="bmwselect" placeholder={props.placeholder} options={props.options} onChange={props.onChange} value={props.options.filter((e) => e.value === props.inputProps.value).pop()} />
    </React.Fragment>
);
export default InputSelect;
